const categories = [
  {
    id: 1,
    name: 'Automobile',
    songCount: 42,
    icon: '🚗',
    gradient: 'from-sky-500 to-indigo-500',
    bgGradient: 'from-sky-50 to-indigo-50',
    songs: [
      { id: 'auto-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Automobile/watermarked_Unique_TVS_new1.MP3" },
      { id: 'auto-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Automobile/watermarked_fluidline_final_1.mp3" },
      { id: 'auto-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Automobile/watermarked_car+spa+hindi+1.mp3" },
      { id: 'auto-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Automobile/GARRARI.mp3" },
      { id: 'auto-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Automobile/Starcarz.mp3" },
      { id: 'auto-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Automobile/carspa.mp3" },
    ],
    image: "/images/jingle_categories/automotive_industry.jpg"
  },
  {
    id: 2,
    name: 'Cosmetics-and-Beauty',
    songCount: 38,
    icon: '💄',
    gradient: 'from-pink-500 to-rose-500',
    bgGradient: 'from-pink-50 to-rose-50',
    songs: [
      { id: 'cos-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Cosmetics-and-Personal-care/watermarked_Reevana_X2.mp3" },
      { id: 'cos-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Cosmetics-and-Personal-care/watermarked_change_your_look_1st_1.mp3" },
      { id: 'cos-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Cosmetics-and-Personal-care/watermarked_ANKITA+BRUSH.mp3" },
      { id: 'cos-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Cosmetics-and-Personal-care/Hair_Speaks_2_watermark.mp3" },
    ],
    image: "/images/jingle_categories/cosmetics_and_beauty.jpg"
  },
  {
    id: 3,
    name: 'Education',
    songCount: 27,
    icon: '🎓',
    gradient: 'from-amber-500 to-orange-500',
    bgGradient: 'from-amber-50 to-orange-50',
    songs: [
      { id: 'edu-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_CHIMALGI_4.mp3" },
      { id: 'edu-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_DCC_1.mp3" },
      { id: 'edu-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_yashwant_classes_1_1.mp3" },
      { id: 'edu-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_stanford_school_full_song.mp3" },
      { id: 'edu-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_Shree_Guru_Vidhya_Peeth_1.mp3" },
      { id: 'edu-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_PTI+-+3+.mp3" },
      { id: 'edu-7', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/watermarked_ethical_public_school_2upd_final.mp3" },
      { id: 'edu-8', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/CareerMarg_1_watermark.mp3" },
      { id: 'edu-9', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/St._Ann_s_School_1_watermark.mp3" },
      { id: 'edu-10', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Education/Ahead_Dental_Acadamy.mp3" },
    ],
    image: "/images/jingle_categories/education.jpg"
  },
  {
    id: 4,
    name: 'Event-Management',
    songCount: 33,
    icon: '🎉',
    gradient: 'from-fuchsia-500 to-purple-500',
    bgGradient: 'from-fuchsia-50 to-purple-50',
    songs: [
      { id: 'event-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Event-Management/watermarked_Shiksha_Mahotsav_2.mp3" },
      { id: 'event-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Event-Management/watermarked_alankrita_resort_new.mp3" }
    ],
    image: "/images/jingle_categories/event_management.jpg"
  },
  {
    id: 5,
    name: 'Fashion',
    songCount: 25,
    icon: '👗',
    gradient: 'from-rose-500 to-purple-600',
    bgGradient: 'from-rose-50 to-purple-50',
    songs: [
      { id: 'fashion-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Fashion/watermarked_diya_silk_2.mp3" },
      { id: 'fashion-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Fashion/watermarked_darshanam_3_2.mp3" },
      { id: 'fashion-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Fashion/watermarked_shringar_houce_1.mp3" },
      { id: 'fashion-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Fashion/Lady_by_Reel_1_watermark.mp3" },
      { id: 'fashion-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Fashion/MOH_1_watermark.mp3" },
    ],
    image: "/images/jingle_categories/fashion.jpg"
  },
  {
    id: 6,
    name: 'Finance',
    songCount: 19,
    icon: '💰',
    gradient: 'from-green-600 to-emerald-500',
    bgGradient: 'from-green-50 to-emerald-50',
    songs: [
      { id: 'finance-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/watermarked_Finance_car_1.mp3" },
      { id: 'finance-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/watermarked_Rightway_Finance _1.mp3" },
      { id: 'finance-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/watermarked_the_brokers_2_1.mp3" },
      { id: 'finance-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/V4U_watermark.mp3" },
      { id: 'finance-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/ICFM_India.mp3" },
      { id: 'finance-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/one_man_trading.mp3" },
      { id: 'finance-7', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/money_devta.mp3" },
      { id: 'finance-8', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Finance/smest.mp3" },
    ],
    image: "/images/jingle_categories/finance.jpg"
  },
  {
    id: 7,
    name: 'Food & Bevrages',
    songCount: 40,
    icon: '🍔',
    gradient: 'from-yellow-500 to-orange-600',
    bgGradient: 'from-yellow-50 to-orange-50',
    songs: [
      { id: 'food-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Food/watermarked_sehgal_correction_1.mp3" },
      { id: 'food-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Food/watermarked_man_shanti_1.mp3" },
      { id: 'food-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Food/watermarked_balaji_rasoi_new_1_2.mp3" },
      { id: 'food-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Food/watermarked_chaat_junction_1_1_final_1.mp3" },
      { id: 'food-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Food/Game_Seekers_Pickle_3_Cover_mp3cut.net_watermark.mp3" },
    ],
    image: "/images/jingle_categories/food.png"
  },
  {
    id: 8,
    name: 'Healthcare',
    songCount: 28,
    icon: '🩺',
    gradient: 'from-teal-500 to-cyan-500',
    bgGradient: 'from-teal-50 to-cyan-50',
    songs: [
      { id: 'health-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/watermarked_Curesia_hospital_1.mp3" },
      { id: 'health-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/watermarked_Matrutva_Fertility_New_updated_1.mp3" },
      { id: 'health-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/watermarked_KMH_HOSPITAL_1.mp3" },
      { id: 'health-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/Livgastro_1_2_watermark.mp3" },
      { id: 'health-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/Livgastro_2_2_watermark.mp3" },
      { id: 'health-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/watermarked_Naritva_3.mp3" },
      { id: 'health-7', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/Dental_Care_Seattle_3_1_.mp3" },
      { id: 'health-8', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/Dental_care_1.mp3" },
      { id: 'health-9', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Healthcare/Dental_care_2.mp3" },
    ],
    image: "/images/jingle_categories/healthcare.jpg"
  },
  {
    id: 9,
    name: 'Interiors',
    songCount: 16,
    icon: '🏠',
    gradient: 'from-gray-600 to-stone-500',
    bgGradient: 'from-gray-50 to-stone-50',
    songs: [
      { id: 'int-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Interiors/watermarked_la_decora_2.mp3" },
      { id: 'int-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Interiors/woodkeeper.mp3" },
      { id: 'int-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Interiors/JBF_Decor_watermark.mp3" },
      { id: 'int-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Interiors/watermarked_wondra_final_jingle.mp3" },
    ],
    image: "/images/jingle_categories/interiors.jpg"
  },
  {
    id: 10,
    name: 'Jewellery',
    songCount: 22,
    icon: '💍',
    gradient: 'from-yellow-600 to-amber-500',
    bgGradient: 'from-yellow-50 to-amber-50',
    songs: [
      { id: 'jewel-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Jewellery/watermarked_HATO_1_CORRECTION_1.mp3" },
      { id: 'jewel-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Jewellery/watermarked_bana_diamond_final_brand_jingle.mp3" },
      { id: 'jewel-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Jewellery/watermarked_Zewar_Mahal_916_01.mp3" },
      { id: 'jewel-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Jewellery/watermarked_Shaan_jewel_final_correction.mp3" },
    ],
    image: "/images/jingle_categories/jewellery.jpg"
  },
  {
    id: 11,
    name: 'Real-Estate',
    songCount: 24,
    icon: '🏡',
    gradient: 'from-blue-600 to-indigo-600',
    bgGradient: 'from-blue-50 to-indigo-50',
    songs: [
      { id: 'real-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Real-Estate/watermarked_vastu p_1.mp3" },
      { id: 'real-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Real-Estate/watermarked_m_sanvi_1_final_upd_new_1.mp3" },
      { id: 'real-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Real-Estate/watermarked_club_reality_final.mp3" },
      { id: 'real-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Real-Estate/watermarked_1XL_1.mp3" },
      { id: 'real-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Real-Estate/Kamal+associate_1_final_new.mp3" },
      { id: 'real-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Real-Estate/Parker_premier_real_estate_1_watermark.mp3" },
    ],
    image: "/images/jingle_categories/real_estate.jpg"
  },
  {
    id: 12,
    name: 'Retail',
    songCount: 31,
    icon: '🛍️',
    gradient: 'from-pink-500 to-red-500',
    bgGradient: 'from-pink-50 to-red-50',
    songs: [
      { id: 'ret-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_shrikanth_agarbatti_2.mp3" },
      { id: 'ret-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_Oswal_soap_1.mp3" },
      { id: 'ret-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_Yellow_Tiger_Masala_4.mp3" },
      { id: 'ret-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_Game_Seekers_Pickle_1.mp3" },
      { id: 'ret-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_Simply_Soho_2.mp3" },
      { id: 'ret-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_hello+india_2_1.mp3" },
      { id: 'ret-7', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Retail/watermarked_doval+fruit+tea_3_upd.mp3" },
    ],
    image: "/images/jingle_categories/retail.jpg"
  },
  {
    id: 13,
    name: 'Tourism',
    songCount: 37,
    icon: '🌍',
    gradient: 'from-cyan-500 to-blue-500',
    bgGradient: 'from-cyan-50 to-blue-50',
    songs: [
      { id: 'tour-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Tourism/watermarked_uni_holiday_1.mp3" },
      { id: 'tour-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Tourism/watermarked_ETI_Tours_2.mp3" },
      { id: 'tour-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Tourism/watermarked_Revax_Cations_1.mp3" },
      { id: 'tour-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Tourism/Fascinating_Andaman_1_watermark.mp3" },
    ],
    image: "/images/jingle_categories/tourism.jpg"
  },
  {
    id: 14,
    name: 'Voiceover',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/watermarked_MARATHI_GL_2.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/watermarked_teleglobal_2.mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/watermarked_ENGLISH_HL_1.mp3" },
      { id: 'voice-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/watermarked_Sheetal_caller_tune_1.mp3" },
      { id: 'voice-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/ratnagiri_kunbi_vikas_patpedhi_2_watermark.mp3" },
      { id: 'voice-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/watermarked_Nutris+female+caller+tune.mp3" },
      { id: 'voice-7', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/watermarked_grampus+voiceover+tune.mp3" },
      { id: 'voice-8', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/Chaitanya_Group.mp3" },
      { id: 'voice-9', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/Swadeshi_Bharat.mp3 " },
      { id: 'voice-10', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/Yashwant_classes.mp3" },
      { id: 'voice-11', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Voiceover/shuddhayu.mp3" },
    ],
    image: "/images/jingle_categories/voiceover.jpg"
  },
  {
    id: 15,
    name: 'Instrumental',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_sample+audio.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_sample+for+chase+aroma_1.mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_sample+for+chase+aroma_2.mp3" },
      { id: 'voice-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_My+Grampus+-+Instrumental+-+3.mp3" },
      { id: 'voice-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_SVD+Jewel+-+Instrumental.mp3" },
      { id: 'voice-6', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_VL+Varenium+-+1.mp3" },
      { id: 'voice-7', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_change+your+looks+-3rd_1+tagline.mp3" },
      { id: 'voice-8', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_shuddhayu_1_tagline_new.mp3" },
      { id: 'voice-9', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Instrumental/watermarked_yashwant_clasess_1_2+tagline.mp3" },
    ],
    image: "/images/jingle_categories/instrumental.webp"
  },
  {
    id: 16,
    name: 'Construction',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/construction/watermarked_A1+gold+sample+female+voice_.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/construction/watermarked_A1+gold+sample+male+voice_.mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/construction/watermarked_A_One+_2.mp3" },
      { id: 'voice-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/construction/End_To_End_Constructions_1_Uncut_watermark.mp3" },
    ],
    image: "/images/jingle_categories/construction.webp"
  },
  {
    id: 17,
    name: 'Suspense',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Crypto/watermarked_crypto+sample_1.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Crypto/watermarked_crypto+sample_2.mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Crypto/watermarked_crypto+sample_3.mp3" },
      { id: 'voice-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Crypto/watermarked_crypto+sample_4.mp3" },
      { id: 'voice-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Crypto/watermarked_crypto+sample_5.mp3" },
    ],
    image: "/images/jingle_categories/suspense.webp"
  },
  {
    id: 18,
    name: 'Solar',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Solar/Watermarked_Solar+Gram+-+2++(1).mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Solar/watermarked_GRE+final_audio+(1).mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Solar/watermarked_Rayshine_1_2.mp3" },
      { id: 'voice-4', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Solar/watermarked_VNB+Solar+_+1++(1).mp3" },
      { id: 'voice-5', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Solar/watermarked_xnergs+new+energetic+tune.mp3" },
    ],
    image: "/images/jingle_categories/solar.webp"
  },
  {
    id: 19,
    name: 'Dairy & Poultry',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/dairy_and_poultry/watermarked_Sardar+cattle+feed+-+1.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/dairy_and_poultry/watermarked_Swadeshi+Bhaarat+-1.mp3" },
    ],
    image: "/images/jingle_categories/dairy.webp"
  },
  {
    id: 20,
    name: 'Electrical & Electronics',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/electrical_and_electronics/watermarked_DA+ELECTRICALS+-1.mp3" },
    ],
    image: "/images/jingle_categories/electrical_and_electronics.webp"
  },
  {
    id: 21,
    name: 'Astrology',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Astrology/Aurita.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Astrology/BHagwat_PRAPTI.mp3" },
    ],
    image: "/images/jingle_categories/astrology.webp"
  },
  {
    id: 22,
    name: 'Clothing',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Clothing/Nakoda_Textiles_mills_2_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Clothing/Nakoda_textile_mills_1_watermark.mp3" },
    ],
    image: "/images/jingle_categories/clothing.webp"
  },
  {
    id: 23,
    name: 'Paints',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Paints/Refracool_1_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Paints/oasis_1_1_watermark.mp3" },
    ],
    image: "/images/jingle_categories/paints.webp"
  },
  {
    id: 24,
    name: 'Sound Systems',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Speaker/Dasska_1_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Speaker/Kyptec_Improved_watermark.mp3" },
    ],
    image: "/images/jingle_categories/speaker.webp"
  },
  {
    id: 25,
    name: 'Industrial Machinery',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Industrial_Machinery/FIDEM_1_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Industrial_Machinery/fluidline_final_2_watermark.mp3" },
    ],
    image: "/images/jingle_categories/machinery.webp"
  },
  {
    id: 26,
    name: 'Perfumes',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Perfumes/Darake_Luxes_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Perfumes/Elxi_Tag_line_2_watermark.mp3" },
    ],
    image: "/images/jingle_categories/perfumes.webp"
  },
  {
    id: 27,
    name: 'Gambling',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Gambling/CNBA.mp3" },
    ],
    image: "/images/jingle_categories/gambling.webp"
  },
  {
    id: 28,
    name: 'Plumbing',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/PVC_Pipe/watermarked_bharat_pipes_6_male_final.mp3" },
    ],
    image: "/images/jingle_categories/plumbing.webp"
  },
  {
    id: 29,
    name: 'E-Commerce',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/E-Commerce/watermarked_grosav+1+new.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/E-Commerce/watermarked_scobikart+1.mp3" },
    ],
    image: "/images/jingle_categories/e-commerce.webp"
  },
  {
    id: 30,
    name: 'Tyres',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Tyres/Atomall_watermark.mp3" },
    ],
    image: "/images/jingle_categories/tyres.webp"
  },
  {
    id: 31,
    name: 'Furniture',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Furniture/Aacess_Tough_door_3_mp3cut.net_watermark.mp3" },
    ],
    image: "/images/jingle_categories/furniture.webp"
  },
  {
    id: 32,
    name: 'Banking',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Banking/Easy_All_Pay.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Banking/PNB.mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Banking/pnb+(1).mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Banking/sangshubh.mp3" },
    ],
    image: "/images/jingle_categories/banking.webp"
  },
  {
    id: 33,
    name: 'Restaurant',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Restaurant/Mughal_cuisine_Cover_watermark.mp3" },
    ],
    image: "/images/jingle_categories/restaurant.webp"
  },
  {
    id: 34,
    name: 'Politics',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Politics/Walls_and_shades_1_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Politics/watermarked_Politian+Sample+(mp3cut.net).mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Politics/yashraj_2_watermark.mp3" },
    ],
    image: "/images/jingle_categories/politics.webp"
  },
  {
    id: 35,
    name: 'NGO',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NGO/Paropkar_2_mp3cut.net_watermark.mp3" },
    ],
    image: "/images/jingle_categories/ngo.webp"
  },
  {
    id: 36,
    name: 'News',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEWS/Option-1-Mahabharat+news-.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEWS/Option-2-Mahabharat+news-.mp3" },
      { id: 'voice-3', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/NEWS/Option-3-Mahabharat+news-.mp3" },
    ],
    image: "/images/jingle_categories/news.webp"
  },
  {
    id: 37,
    name: 'Transportation',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Transportation-Delivery/Apna_Packers_and_Movers.mp3" },
    ],
    image: "/images/jingle_categories/transportation.webp"
  },
  {
    id: 38,
    name: 'Comic',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Comic/MN_Comic_Studios.mp3" },
    ],
    image: "/images/jingle_categories/comic.webp"
  },
  {
    id: 39,
    name: 'Business',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Business/agroha.mp3" },
    ],
    image: "/images/jingle_categories/business.webp"
  },
  {
    id: 40,
    name: 'B2B Manufacturing',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/B2B-Manufacturing/Green_trade_india_.mp3" },
    ],
    image: "/images/jingle_categories/B2B_anufacturing.webp"
  },
  {
    id: 41,
    name: 'Marketing',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Marketing/mayank%27s_design.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Marketing/your_business.mp3" },
    ],
    image: "/images/jingle_categories/marketing.webp"
  },
  {
    id: 42,
    name: 'Lubricants',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Lubricants/Engine_Oil_English.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Lubricants/Engine_Oil_Hindi.mp3" },
    ],
    image: "/images/jingle_categories/lubricants.webp"
  },
  {
    id: 43,
    name: 'Technology',
    songCount: 18,
    icon: '🎙️',
    gradient: 'from-purple-600 to-violet-600',
    bgGradient: 'from-purple-50 to-violet-50',
    songs: [
      { id: 'voice-1', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Technology/IT_services_watermark.mp3" },
      { id: 'voice-2', url: "https://f003.backblazeb2.com/file/digikore-jingles-category-collection/Technology/watermarked_Teleglobals+-+1+.mp3" },
    ],
    image: "/images/jingle_categories/technology.webp"
  },
];

export default categories;
